import * as React from 'react';

import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import 'minireset.css';
// import { Link } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import mediaQueries from 'src/constants/responsive';
import stylesheet, { mainColor, secondaryColor } from 'src/constants/stylesheet';
import { Language } from 'src/utils/Languages';
import ViewMonitor from 'src/utils/ViewMonitor';
import { useApi } from '../@context/Api';
import spacing from '../constants/spacing';

export type FooterProps = {
  pageType: string;
};

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',

      [mediaQueries.Mobile]: {
        padding: spacing.Gutter.Mobile,
        flexDirection: 'column'
      },
      [mediaQueries.Tablet]: {
        padding: spacing.Gutter.Tablet,
      },
      [mediaQueries.AfterTablet]: {
        padding: spacing.Gutter.Desktop,
      },
    },
    infosContent: {
      [mediaQueries.Mobile]: {
        paddingBottom: spacing.Gutter.Mobile,
      },
    },
    info: {
      display: 'inline-block',
      paddingRight: 20,
      color: secondaryColor,
    },
    legalLink: {
      display: 'inline-block',
      paddingRight: 20,
      color: secondaryColor,
      '&:hover': {
        color: mainColor
      }
    },
    socialContent: {
    },
    socialLink: {
      display: 'inline-block',
      color: secondaryColor,

      [mediaQueries.Mobile]: {
        paddingRight: 20,
      },
      [mediaQueries.AfterMobile]: {
        paddingLeft: 20,
      },

      '&:hover': {
        color: mainColor,
      }
    },
    hide: {
      display: 'none'
    },
    hideCopywrite: {
      ...stylesheet.Hide,
    },
    hideSocial: {
      ...stylesheet.Hide,
      transitionDelay: '100ms'
    },
    show: {
      ...stylesheet.Show
    }
  }));

const Footer: React.FC<FooterProps> = ({ pageType }) => {
  const cls = useStyles();
  const { app } = useApi();

  const config = app && app.Config;
  const legal = app && app.LegalInformation;

  return (
    <footer className={classNames(cls.root, pageType === "Artists" && cls.hide)}>
      <ViewMonitor once={true}>{(intersect) =>
        <div className={classNames(cls.infosContent, cls.hideCopywrite, intersect && cls.show)}>
          <div className={cls.info}>© 2019 Rabouan Moussion</div>
          {legal && <Link to={`/${Language}/${legal.UID}`} className={cls.legalLink}>{legal.Title}</Link>}
        </div>
      }
      </ViewMonitor>
      <ViewMonitor once={true}>{(intersect) =>
        <div className={classNames(cls.socialContent, cls.hideSocial, intersect && cls.show)}>
          {config && config.Facebook &&
            <a target="_blank" href={config.Facebook} className={cls.socialLink}>Facebook</a>}
          {config && config.Twitter &&
            <a target="_blank" href={config.Twitter} className={cls.socialLink}>Twitter</a>}
          {config && config.Instagram &&
            <a target="_blank" href={config.Instagram} className={cls.socialLink}>Instagram</a>}
          {config && config.Newsletter &&
            <Link to={`${config.Newsletter}#newsletter`} smooth={true} className={cls.socialLink}>Newsletter</Link>}
        </div>
      }
      </ViewMonitor>
    </footer>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.tsx